import { Home, Building2 } from "lucide-react";

export const emptyAddress = {
  full_name: "",
  line1: "",
  line2: "",
  city: "",
  state: "",
  pincode: "",
  landmark: "",
  type: "home",
};

const labelCls = "text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-stone";
const fieldCls = (error) =>
  `mt-2 w-full border bg-brand-surface px-4 py-3.5 text-sm text-brand-charcoal outline-none transition-colors placeholder:text-brand-stone/50 focus:border-brand-gold ${
    error ? "border-red-400" : "border-brand-sand"
  }`;

export const validateAddress = (a) => {
  const e = {};
  if (!a.full_name?.trim()) e.full_name = "Please enter the full name.";
  if (!a.line1?.trim()) e.line1 = "Address line is required.";
  if (!a.city?.trim()) e.city = "City is required.";
  if (!a.state?.trim()) e.state = "State is required.";
  if (!/^\d{6}$/.test((a.pincode || "").trim())) e.pincode = "Enter a 6-digit PIN code.";
  return e;
};

const TextField = ({ label, k, value, onChange, error, idPrefix, ...rest }) => (
  <label className="block">
    <span className={labelCls}>{label}</span>
    <input
      value={value[k] || ""}
      onChange={(e) => onChange({ ...value, [k]: e.target.value })}
      data-testid={`${idPrefix}-${k}`}
      className={fieldCls(error)}
      {...rest}
    />
    {error && (
      <span className="mt-1.5 block text-[11px] text-red-600" data-testid={`${idPrefix}-${k}-error`}>
        {error}
      </span>
    )}
  </label>
);

// Reusable saved-address form fields (Full Name, address lines, Home/Office type).
export const AddressFields = ({ value, onChange, errors = {}, idPrefix = "addr" }) => (
  <div className="grid gap-5 sm:grid-cols-2">
    <div className="sm:col-span-2">
      <TextField label="Full name" k="full_name" value={value} onChange={onChange} error={errors.full_name} idPrefix={idPrefix} placeholder="Recipient name" autoComplete="name" />
    </div>
    <div className="sm:col-span-2">
      <TextField label="Address line 1" k="line1" value={value} onChange={onChange} error={errors.line1} idPrefix={idPrefix} placeholder="House / flat, street" autoComplete="address-line1" />
    </div>
    <div className="sm:col-span-2">
      <TextField label="Address line 2 (optional)" k="line2" value={value} onChange={onChange} idPrefix={idPrefix} placeholder="Area, colony" autoComplete="address-line2" />
    </div>
    <TextField label="City" k="city" value={value} onChange={onChange} error={errors.city} idPrefix={idPrefix} placeholder="City" autoComplete="address-level2" />
    <TextField label="State" k="state" value={value} onChange={onChange} error={errors.state} idPrefix={idPrefix} placeholder="State" autoComplete="address-level1" />
    <TextField label="PIN code" k="pincode" value={value} onChange={onChange} error={errors.pincode} idPrefix={idPrefix} placeholder="6-digit PIN" inputMode="numeric" />
    <TextField label="Landmark (optional)" k="landmark" value={value} onChange={onChange} idPrefix={idPrefix} placeholder="Nearby landmark" />
    <div className="sm:col-span-2">
      <span className={labelCls}>Address type</span>
      <div className="mt-2 flex gap-3">
        {[
          { v: "home", label: "Home", Icon: Home },
          { v: "office", label: "Office", Icon: Building2 },
        ].map(({ v, label, Icon }) => (
          <button
            type="button"
            key={v}
            data-testid={`${idPrefix}-type-${v}`}
            onClick={() => onChange({ ...value, type: v })}
            className={`inline-flex items-center gap-2 border px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.14em] transition-colors ${
              value.type === v ? "border-brand-gold bg-brand-gold/10 text-brand-gold" : "border-brand-sand text-brand-stone hover:border-brand-gold"
            }`}
          >
            <Icon className="h-4 w-4" /> {label}
          </button>
        ))}
      </div>
    </div>
  </div>
);
